function equal(a, b) {
  if (a === b)
    return true
  if (Array.isArray(a) && Array.isArray(b)) {
    // Array compare
    if (a.length !== b.length)
      return false

    const length = a.length
    for (let i = 0; i < length; i++) {
      if (!equal(a[i], b[i]))
        return false
    }
    return true
  }
  if (a !== null && typeof a === 'object' && b !== null && typeof b === 'object') {
    const ak = Object.keys(a).sort()
    const bk = Object.keys(b).sort()
    if (!equal(ak, bk))
      return false
    for (const key of ak) {
      if (!equal(a[key], b[key]))
        return false
    }
    return true
  }
  return false
}

// The a and b should be sorted
function differ_list(a = [], b = [], id_key) {
  const adds = []
  const removes = []
  const changes = []

  const alen = a.length
  const blen = b.length

  let cusor_b = 0

  function markAdded(from, to) {
    for (let i = from; i < to; i++)
      adds.push(b[i])
  }

  for (let ia = 0; ia < alen; ia++) {
    const a_item = a[ia]
    const a_key = id_key ? a_item[id_key] : a_item

    // Search items in b which matches a_item
    let found = false
    for (let ib = cusor_b; ib < blen; ib++) {
      const b_item = b[ib]
      const b_key = id_key ? b_item[id_key] : b_item

      if (equal(a_key, b_key)) {
        found = true
        markAdded(cusor_b, ib)
        cusor_b = ib + 1

        if (!equal(a_item, b_item)) {
          // The keys matched, but the value is not
          changes.push({ from: a_item, to: b_item })
        }
        break
      }
    }

    if (!found) {
      // Not matches, so a is deleted in b
      removes.push(a_item)
    }
  }

  return { adds, removes, changes }
}

export default {
  equal,
  list: differ_list,
}



// WEBPACK FOOTER //
// ./modules/differ/index.js